// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { DesignUpdatesAvailable_PlanUpdateFragmentDoc } from './components/DesignUpdatesAvailableButton.generated';
import { PotentialOperationDetailsFragmentDoc } from '../../../../queries/fragments.generated';
import { VersionableFragmentDoc } from '../../../../components/ReadyPlanVersionHeader.generated';
import { ReadyPlanLikeButtonMenuAggregateDraftFragmentDoc } from '../../../../components/ReadyPlanButtonMenu.generated';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DesignPackageConfiguratorQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  versionId?: Types.InputMaybe<Types.Scalars['ID']['input']>;
}>;


export type DesignPackageConfiguratorQuery = { __typename?: 'Query', designPackage: { __typename?: 'DesignPackage', id: string, name: string, startedAt?: Types.Scalars['DateTime']['input'] | null | undefined, completedAt?: Types.Scalars['DateTime']['input'] | null | undefined, copyInProgress: boolean, cloneInProgress: boolean, description?: string | null | undefined, code?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], availableUpdates: Array<{ __typename?: 'DesignPackagePlanUpdate', id: string, createdAt: Types.Scalars['DateTime']['input'], planVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, versionNotes?: string | null | undefined, readyPlan:
          | { __typename?: 'ReadyPlan', id: string, name: string }
          | { __typename?: 'PlanPackage', id: string, name: string }
          | { __typename?: 'DesignPackage', id: string, name: string }
          | { __typename?: 'ProductOffering', id: string, name: string }
        , tliVersions: Array<{ __typename?: 'TakeoffLineItemVersion', id: string, changeType: string, identity: { __typename?: 'TakeoffLineItem', id: string, isPlaceholderMaterial: boolean } }>, rplVersions: Array<{ __typename?: 'ReadyPlanLocationVersion', id: string, changeType: string }> } }>, location: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation, name: string }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, displayVersion: string, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, aggregateActive?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } } | null | undefined, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number, forDesignPackages: boolean, forDesignUpgrade: boolean, isPlanPackage: boolean, group: { __typename?: 'GlobalOptionGroup', id: string, designPackageTagColor?: string | null | undefined }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, order: number }> }>, planPackages: Array<{ __typename?: 'PlanPackage', id: string, name: string }>, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, displayVersion: string, updatedAt: Types.Scalars['DateTime']['input'], status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus, name: string } }> } };

export type SaveDesignPackageCycleMutationVariables = Types.Exact<{
  input: Types.SaveDesignPackageInput;
}>;


export type SaveDesignPackageCycleMutation = { __typename?: 'Mutation', saveDesignPackage: { __typename?: 'SaveDesignPackageResult', designPackage: { __typename?: 'DesignPackage', id: string, startedAt?: Types.Scalars['DateTime']['input'] | null | undefined, completedAt?: Types.Scalars['DateTime']['input'] | null | undefined } } };

export type DesignPackageConfigurator_DesignPackageFragment = { __typename?: 'DesignPackage', id: string, name: string, startedAt?: Types.Scalars['DateTime']['input'] | null | undefined, completedAt?: Types.Scalars['DateTime']['input'] | null | undefined, copyInProgress: boolean, cloneInProgress: boolean, description?: string | null | undefined, code?: string | null | undefined, updatedAt: Types.Scalars['DateTime']['input'], availableUpdates: Array<{ __typename?: 'DesignPackagePlanUpdate', id: string, createdAt: Types.Scalars['DateTime']['input'], planVersion: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, versionNotes?: string | null | undefined, readyPlan:
        | { __typename?: 'ReadyPlan', id: string, name: string }
        | { __typename?: 'PlanPackage', id: string, name: string }
        | { __typename?: 'DesignPackage', id: string, name: string }
        | { __typename?: 'ProductOffering', id: string, name: string }
      , tliVersions: Array<{ __typename?: 'TakeoffLineItemVersion', id: string, changeType: string, identity: { __typename?: 'TakeoffLineItem', id: string, isPlaceholderMaterial: boolean } }>, rplVersions: Array<{ __typename?: 'ReadyPlanLocationVersion', id: string, changeType: string }> } }>, location: { __typename?: 'DesignPackageLocationDetail', code: Types.DesignPackageLocation, name: string }, status: { __typename?: 'ReadyPlanStatusDetail', code: Types.ReadyPlanStatus, name: string }, canEdit: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> }, version: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateLatest: { __typename?: 'ReadyPlanAggregateVersion', id: string }, aggregateDraft?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, displayVersion: string, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus }, canDelete: { __typename?: 'PotentialOperation2', allowed: boolean, disabledReasons: Array<{ __typename?: 'Reason', message: string }> } } | null | undefined, aggregateActive?: { __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, promotedAt?: Types.Scalars['DateTime']['input'] | null | undefined, promotedBy?: { __typename?: 'User', id: string, name: string } | null | undefined, status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus } } | null | undefined, optionGroups: Array<{ __typename?: 'ReadyPlanOptionGroup', id: string, name: string, order: number, forDesignPackages: boolean, forDesignUpgrade: boolean, isPlanPackage: boolean, group: { __typename?: 'GlobalOptionGroup', id: string, designPackageTagColor?: string | null | undefined }, options: Array<{ __typename?: 'ReadyPlanOption', id: string, name: string, order: number }> }>, planPackages: Array<{ __typename?: 'PlanPackage', id: string, name: string }>, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, displayVersion: string, updatedAt: Types.Scalars['DateTime']['input'], status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus, name: string } }> };

export type DesignPackageConfigurator_DesignPackage_VersionsFragment = { __typename?: 'DesignPackage', id: string, aggregateVersions: Array<{ __typename?: 'ReadyPlanAggregateVersion', id: string, version?: number | null | undefined, displayVersion: string, updatedAt: Types.Scalars['DateTime']['input'], status: { __typename?: 'AggregateVersionStatusDetail', code: Types.AggregateVersionStatus, name: string } }> };

export const DesignPackageConfigurator_DesignPackage_VersionsFragmentDoc = gql`
    fragment DesignPackageConfigurator_DesignPackage_Versions on DesignPackage {
  id
  aggregateVersions {
    id
    version
    displayVersion
    status {
      code
      name
    }
    updatedAt
  }
}
    `;
export const DesignPackageConfigurator_DesignPackageFragmentDoc = gql`
    fragment DesignPackageConfigurator_DesignPackage on DesignPackage {
  id
  name
  startedAt
  completedAt
  copyInProgress
  cloneInProgress
  availableUpdates {
    ...DesignUpdatesAvailable_PlanUpdate
  }
  name
  description
  code
  location {
    code
    name
  }
  status {
    code
    name
  }
  canEdit {
    ...PotentialOperationDetails
  }
  version {
    id
  }
  aggregateLatest {
    id
  }
  aggregateDraft {
    ...Versionable
    ...ReadyPlanLikeButtonMenuAggregateDraft
  }
  aggregateActive {
    ...Versionable
  }
  updatedAt
  ...DesignPackageConfigurator_DesignPackage_Versions
  optionGroups {
    id
    name
    order
    group {
      id
      designPackageTagColor
    }
    forDesignPackages
    forDesignUpgrade
    isPlanPackage
    options {
      id
      name
      order
    }
  }
  planPackages {
    ...Named
  }
}
    ${DesignUpdatesAvailable_PlanUpdateFragmentDoc}
${PotentialOperationDetailsFragmentDoc}
${VersionableFragmentDoc}
${ReadyPlanLikeButtonMenuAggregateDraftFragmentDoc}
${DesignPackageConfigurator_DesignPackage_VersionsFragmentDoc}
${NamedFragmentDoc}`;
export const DesignPackageConfiguratorDocument = gql`
    query DesignPackageConfigurator($id: ID!, $versionId: ID) {
  designPackage(id: $id, versionId: $versionId) {
    ...DesignPackageConfigurator_DesignPackage
  }
}
    ${DesignPackageConfigurator_DesignPackageFragmentDoc}`;

/**
 * __useDesignPackageConfiguratorQuery__
 *
 * To run a query within a React component, call `useDesignPackageConfiguratorQuery` and pass it any options that fit your needs.
 * When your component renders, `useDesignPackageConfiguratorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDesignPackageConfiguratorQuery({
 *   variables: {
 *      id: // value for 'id'
 *      versionId: // value for 'versionId'
 *   },
 * });
 */
export function useDesignPackageConfiguratorQuery(baseOptions: ApolloReactHooks.QueryHookOptions<DesignPackageConfiguratorQuery, DesignPackageConfiguratorQueryVariables> & ({ variables: DesignPackageConfiguratorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DesignPackageConfiguratorQuery, DesignPackageConfiguratorQueryVariables>(DesignPackageConfiguratorDocument, options);
      }
export function useDesignPackageConfiguratorLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DesignPackageConfiguratorQuery, DesignPackageConfiguratorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DesignPackageConfiguratorQuery, DesignPackageConfiguratorQueryVariables>(DesignPackageConfiguratorDocument, options);
        }
// @ts-ignore
export function useDesignPackageConfiguratorSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageConfiguratorQuery, DesignPackageConfiguratorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DesignPackageConfiguratorQuery, DesignPackageConfiguratorQueryVariables>;
export function useDesignPackageConfiguratorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageConfiguratorQuery, DesignPackageConfiguratorQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DesignPackageConfiguratorQuery | undefined, DesignPackageConfiguratorQueryVariables>;
export function useDesignPackageConfiguratorSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DesignPackageConfiguratorQuery, DesignPackageConfiguratorQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DesignPackageConfiguratorQuery, DesignPackageConfiguratorQueryVariables>(DesignPackageConfiguratorDocument, options);
        }
export type DesignPackageConfiguratorQueryHookResult = ReturnType<typeof useDesignPackageConfiguratorQuery>;
export type DesignPackageConfiguratorLazyQueryHookResult = ReturnType<typeof useDesignPackageConfiguratorLazyQuery>;
export type DesignPackageConfiguratorSuspenseQueryHookResult = ReturnType<typeof useDesignPackageConfiguratorSuspenseQuery>;
export type DesignPackageConfiguratorQueryResult = ApolloReactCommon.QueryResult<DesignPackageConfiguratorQuery, DesignPackageConfiguratorQueryVariables>;
export const SaveDesignPackageCycleDocument = gql`
    mutation SaveDesignPackageCycle($input: SaveDesignPackageInput!) {
  saveDesignPackage(input: $input) {
    designPackage {
      id
      startedAt
      completedAt
    }
  }
}
    `;

/**
 * __useSaveDesignPackageCycleMutation__
 *
 * To run a mutation, you first call `useSaveDesignPackageCycleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveDesignPackageCycleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveDesignPackageCycleMutation, { data, loading, error }] = useSaveDesignPackageCycleMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSaveDesignPackageCycleMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<SaveDesignPackageCycleMutation, SaveDesignPackageCycleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<SaveDesignPackageCycleMutation, SaveDesignPackageCycleMutationVariables>(SaveDesignPackageCycleDocument, options);
      }
export type SaveDesignPackageCycleMutationHookResult = ReturnType<typeof useSaveDesignPackageCycleMutation>;
export type SaveDesignPackageCycleMutationResult = ApolloReactCommon.MutationResult<SaveDesignPackageCycleMutation>;